import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Settings, Calendar, ShoppingCart, Package } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { appPath } from '../routes/appPaths';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { totalCount, total } = useCart();

  const isCart = location.pathname === appPath('/cart');
  const isOrder = location.pathname === appPath('/home');
  const isEvents = location.pathname.startsWith(appPath('/events'));
  const isSettings = location.pathname === appPath('/settings');

  return (
    <div
      className="fixed left-0 right-0 z-50"
      style={{
        bottom: 'max(16px, env(safe-area-inset-bottom), var(--tg-safe-area-inset-bottom, 0px))',
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 8,
      }}
    >
      <div
        className="max-w-md mx-auto flex items-center justify-between px-4 py-3 rounded-3xl"
        style={{
          background: 'rgba(18,18,18,0.92)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid rgba(255,255,255,0.12)',
          boxShadow: '0 8px 28px rgba(0,0,0,0.35)',
        }}
      >
        <NavBtn icon={<Package size={21} />} label="Заказ" onClick={() => navigate(appPath('/home'))} active={isOrder} />
        <NavBtn icon={<Calendar size={21} />} label="События" onClick={() => navigate(appPath('/events'))} active={isEvents} />
        <NavBtn icon={<Settings size={21} />} label="Профиль" onClick={() => navigate(appPath('/settings'))} active={isSettings} />

        <button
          onClick={() => navigate(appPath('/cart'))}
          className="flex items-center gap-2 px-5 py-2.5 rounded-2xl font-semibold text-sm transition-all active:scale-95 tracking-[0.06em] uppercase"
          style={{
            background: isCart ? '#fff' : 'rgba(255,255,255,0.92)',
            color: '#0a0a0a',
            fontFamily: 'Manrope, sans-serif',
          }}
        >
          <ShoppingCart size={17} />
          <span className="tabular-nums">
            {totalCount > 0 ? `${total.toLocaleString('ru-RU')} ₽` : 'Корзина'}
          </span>
        </button>
      </div>
    </div>
  );
}

function NavBtn({
  icon,
  label,
  onClick,
  active,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  active: boolean;
}) {
  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center gap-0.5 px-2 py-1 transition-all"
      style={{
        color: active ? '#fff' : 'rgba(255,255,255,0.4)',
        fontFamily: 'Manrope, sans-serif',
      }}
    >
      {icon}
      <span className="text-[10px] font-semibold tracking-[0.06em] uppercase">{label}</span>
    </button>
  );
}
